import { useEffect, useState } from "react";
import { NasMark } from "@/components/brand/NasLogo";

export const SiteNav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 24);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <header className="ns-nav" data-scrolled={scrolled ? "1" : "0"} data-testid="ns-nav">
      <a className="ns-brand" href="#top" data-testid="ns-nav-brand">
        <NasMark size={18} />
        <span>Norwegian AI Summit</span>
      </a>
      <span className="ns-nav-mid" data-testid="ns-nav-meta">13 April 2027 · Grieghallen, Bergen</span>
      <div className="ns-nav-right">
        <nav className="ns-nav-links" aria-label="Sections">
          <a href="#programme" data-testid="ns-nav-programme">Programme</a>
          <a href="#partners" data-testid="ns-nav-partners">Partners</a>
        </nav>
        <a className="ns-btn sm" href="#invite" data-testid="ns-nav-cta">
          <span className="long">Request an invitation</span>
          <span className="short">Invitation</span>
        </a>
      </div>
    </header>
  );
};
